(ns manage.campaign.list-view
  (:require ["@mui/material/CircularProgress$default" :as CircularProgress]
            ["@mui/material/Stack$default" :as Stack]
            ["src/svg/artwork/cards.svg$default" :as CardsArtwork]
            ["src/svg/artwork/masonry.svg$default" :as Masonry]
            [common.patterns.empty-state-view :refer [empty-state-view]]
            [common.queries :refer [use-query]]
            [common.resource.query.campaign :as cq]
            [common.url-template :as url-tpl]
            [manage.campaign.hooks :as ch]
            [manage.campaign.link.link-campaign-modal]
            [manage.campaign.table.view :refer [campaign-datagrid
                                                create-campaign-button
                                                link-campaign-button
                                                new-campaign-button]]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defn get-content
  [os-project-available?]
  (if os-project-available?
    {:title "Get started"
     :description "You don't have any campaigns in this project. Create a new campaign or add an existing one to get started."
     :artwork CardsArtwork
     :button ($ Stack
                {:direction "row"
                 :gap 1}
                ($ link-campaign-button)
                ($ create-campaign-button))}
    {:title "Create a campaign"
     :description "You have no campaigns yet. Create one to get started."
     :artwork Masonry
     :button ($ new-campaign-button)}))

(defui empty-view [{:keys [os-project-available?]}]
  (let [url-context (use-subscribe [:url-context])
        content (get-content os-project-available?)]
    ($ empty-state-view
       {:title (:title content)
        :description (:description content)
        :artwork (:artwork content)
        :docs-href (url-tpl/render :docs/article (assoc url-context :slug "24147219143196-How-to-Create-a-Campaign-Adset"))
        :actions (:button content)})))

(defui loading-view []
  ($ Stack
     {:alignItems "center"
      :justifyContent "center"
      :sx #js {:flex 1}}
     ($ CircularProgress)))

(defui list-view-contents []
  (let [{:keys [advertiser-id]} (use-subscribe [:url-context])
        {:keys [data isSuccess isLoading]} (use-query (cq/campaigns-query {:advertiser-id advertiser-id}))

        active-campaigns (filter #(= (:archived %) false) data)
        {:keys [mapped-campaign? os-project-available?]} (ch/use-wpp-open-project)]
    (cond
      isLoading ($ loading-view)

      (and isSuccess (> (count active-campaigns) 0)
           ;; the case when CO opened from WPP open project but campaign not mapped yet
           (not (and os-project-available? (not mapped-campaign?))))
      ($ campaign-datagrid)

      :else ($ empty-view {:os-project-available? os-project-available?}))))
